import { useMemo } from "react";
import { array, object, ref, string } from "yup";
import { FormField, type UserFormProps } from "./types";
import { isDomainRequired } from "./helpers";
import { REGEXP } from "consts/validation";


type UseValidationSchemaArg = Pick<UserFormProps, 'bootstrapData'> & {
    readonly isNew: boolean;
};

const useValidationSchema = ({
    isNew,
    bootstrapData: {
        roles
    }
}: UseValidationSchemaArg) =>
    useMemo(() =>
        object()
            .shape({
                [FormField.FirstName]: string()
                    .min(3)
                    .max(50)
                    .required()
                    .label('First Name'),
                [FormField.LastName]: string()
                    .min(3)
                    .max(50)
                    .required()
                    .label('Last Name'),
                [FormField.Email]: string()
                    .email("Email must be a valid email")
                    .required("Email is a required field"),
                [FormField.RoleId]: string()
                    .required(),
                // [FormField.Merchants]: array()
                //     .of(object().shape({
                //         id: string().required(),
                //         name: string().required()
                //     }))
                //     .when(FormField.RoleId, {
                //         is: isMerchantRequired(roles),
                //         then: shema => shema
                //             .min(1, "Renalda test")
                //             .required("This field required")
                //     }),
                [FormField.Domains]: array()
                    .of(object().shape({
                        id: string().required(),
                        name: string().required()
                    }))
                    .when(FormField.RoleId, {
                        is: isDomainRequired(roles),
                        then: shema => shema
                            .min(1, "This field required")
                    }),
                ...(
                    isNew
                        ? ({
                            [FormField.Password]: string()
                                .min(8)
                                .matches(REGEXP.Uppercase, 'At least one uppercase letter (A-Z)')
                                .matches(REGEXP.Lowercase, 'At least one lowercase letter (a-z)')
                                .matches(REGEXP.Numbers, 'At least one number (0-9)')
                                .matches(REGEXP.SpecialChars, 'At least one special character (e.g., !, @, #, $)')
                                .required()
                                .label('Password'),

                            [FormField.PasswordConfirmation]: string()
                                .oneOf([ref(FormField.Password), null], 'Passwords don’t match. Try again')
                                .required()
                                .label('Confirm Password')

                        })
                        : ({
                            [FormField.Password]: string()
                                .min(8)
                                .matches(REGEXP.Uppercase, 'At least one uppercase letter (A-Z)')
                                .matches(REGEXP.Lowercase, 'At least one lowercase letter (a-z)')
                                .matches(REGEXP.Numbers, 'At least one number (0-9)')
                                .matches(REGEXP.SpecialChars, 'At least one special character (e.g., !, @, #, $)')
                                .notRequired()
                                .nullable()
                                .label('Password'),

                            [FormField.PasswordConfirmation]: string()
                                .oneOf([ref(FormField.Password), null], 'Passwords don’t match. Try again')
                                .notRequired()
                                .nullable()
                                .label('Confirm Password')
                        })
                )
            }), [isNew, roles]);

export default useValidationSchema;
